import { ErrorFallback } from './ErrorFallback';

export default ErrorFallback;
